import { useField } from "formik";

import { RadioGroup, RadioGroupProps } from "./RadioGroup";

interface Props extends RadioGroupProps {
  name: string;
  label: string;
}

/**
 * @deprecated see RadioGroupFormikField
 */
export function RadioGroupField({ name, onChange, errors, ...props }: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <RadioGroup
      {...field}
      {...props}
      onChange={(value: string) => {
        onChange?.(value);
        helpers.setValue(value);
      }}
      errors={errors || (meta.touched && meta.error)}
    />
  );
}
